import React from 'react'

function Mentors() {
  return (
    <div>
      <p>mentors</p>
    </div>
  )
}

export default Mentors;